import { Phone, Clock, Mail, MapPin } from "lucide-react";
import { business } from "@/lib/business";

const TopBar = () => {
  return (
    <div className="hidden sm:block bg-[hsl(var(--accent-dark))] text-white/85">
      <div className="container-max flex items-center justify-between gap-4 px-4 py-2 text-xs lg:text-[13px]">
        <div className="flex items-center gap-5">
          <a
            href={business.emailHref}
            className="flex items-center gap-2 hover:text-[hsl(var(--primary-bright))] transition-colors"
          >
            <Mail className="h-3.5 w-3.5 text-[hsl(var(--primary-bright))] shrink-0" />
            <span className="truncate max-w-[240px] lg:max-w-none">{business.email}</span>
          </a>
          <span className="hidden lg:flex items-center gap-2">
            <MapPin className="h-3.5 w-3.5 text-[hsl(var(--primary-bright))] shrink-0" />
            <span>{business.addressLine}</span>
          </span>
        </div>
        <div className="flex items-center gap-5">
          <span className="hidden md:flex items-center gap-2">
            <Clock className="h-3.5 w-3.5 text-[hsl(var(--primary-bright))] shrink-0" />
            <span>
              {business.hours.label} {business.hours.time}
            </span>
          </span>
          <a
            href={business.phoneHref}
            className="flex items-center gap-2 font-semibold text-white hover:text-[hsl(var(--primary-bright))] transition-colors"
          >
            <Phone className="h-3.5 w-3.5 text-[hsl(var(--primary-bright))] shrink-0" />
            <span>{business.phone}</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
